/**
 * 404. Mounted on the root route, so it covers both an unknown path and a
 * `notFound()` thrown from a loader.
 *
 * `ui-patterns.md` empty-state anatomy: a bold one-line headline, one
 * supporting sentence, exactly one primary CTA. Never a bare "Not found."
 */
import { Button } from "@sportsmet/ui";
import type { ReactNode } from "react";

import { HomeLink } from "./HomeLink";

export const NotFoundScreen = (): ReactNode => (
  <div className="mx-auto flex max-w-[480px] flex-col items-center gap-4 py-12 text-center">
    <h1 className="text-h1 text-ink">We couldn&rsquo;t find that page</h1>
    <p className="text-body text-ink-secondary">
      The link may be out of date, or the pool it pointed to may have been
      closed.
    </p>
    <Button variant="primary" fullWidth asChild className="md:w-auto">
      <HomeLink>Go to home</HomeLink>
    </Button>
  </div>
);
